/**
 * Void Barrier: parede de energia que corta o mapa em z = gate.barrierZ e impede
 * o acesso ao Alpha Den até 3 Elites caírem. Bloqueia fisicamente o player (clamp de Z)
 * enquanto fechada. Estado (aberto/fechado) é persistido via GameProgress.
 */
import * as THREE from "three";
import { GameConfig } from "../config/GameConfig";
import { energyMat } from "./Materials";

export class VoidBarrier {
  private readonly mesh: THREE.Mesh;
  private readonly mat: THREE.MeshBasicMaterial;
  private readonly cfg = GameConfig.gate;
  private _open = false;
  private regionActive = true; // false na Região 2 (o gate é da Região 1)
  private shimmer = 0;

  constructor(scene: THREE.Scene) {
    // 10.9BQ — energia da biblioteca; clone porque a opacidade tremula no update
    this.mat = energyMat(0x7c4dff, "disc").clone();
    this.mat.opacity = 0.32;
    this.mesh = new THREE.Mesh(new THREE.PlaneGeometry(this.cfg.barrierWidth, this.cfg.barrierHeight), this.mat);
    this.mesh.position.set(0, this.cfg.barrierHeight / 2, this.cfg.barrierZ);
    scene.add(this.mesh);
  }

  get open(): boolean {
    return this._open;
  }

  setOpen(open: boolean): void {
    this._open = open;
    this.mesh.visible = this.regionActive && !open;
  }

  /** Ativa/desativa o gate (Região 1). Na Região 2 fica oculto e não bloqueia. */
  setRegionActive(v: boolean): void {
    this.regionActive = v;
    this.mesh.visible = v && !this._open;
  }

  update(dt: number): void {
    if (!this.regionActive || this._open) return;
    this.shimmer += dt * 2;
    this.mat.opacity = 0.26 + Math.sin(this.shimmer) * 0.1;
  }

  /** Enquanto fechada, impede o player de cruzar para o norte (z < barrierZ). */
  block(pos: THREE.Vector3, radius: number): void {
    if (!this.regionActive || this._open) return;
    const limit = this.cfg.barrierZ + radius + 0.2;
    if (pos.z < limit) pos.z = limit;
  }
}
